import { siteBrand } from '@/mocks/home';

const footerColumns = [
  {
    title: '关于糖豆',
    links: ['平台介绍', '品牌故事', '加入我们', '媒体报道'],
  },
  {
    title: '主播与达人',
    links: ['主播入驻', '实名认证', '开播规范', '激励计划'],
  },
  {
    title: '内容与社区',
    links: ['内容规范', '社区公约', '举报指引', '青少年守护'],
  },
  {
    title: '帮助与反馈',
    links: ['常见问题', '意见反馈', '客服中心', '隐私政策'],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-6">
          <div className="col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{siteBrand.name}</span>
            </div>
            <p className="mt-4 max-w-xs text-xs leading-relaxed text-foreground-600 md:text-sm">
              汇聚人气主播与网红达人，高颜值小姐姐、女神级主播每日开播，精彩短视频与直播内容同步更新。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {siteBrand.tagline.split(' · ').map((word) => (
                <span key={word} className="rounded-full bg-secondary-100 px-3 py-1 text-[11px] font-medium text-secondary-900">
                  {word}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-950">
                <a href="#top" className="cursor-pointer transition-colors hover:text-primary-600">
                  {column.title}
                </a>
              </h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {column.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="cursor-pointer text-xs text-foreground-600 transition-colors hover:text-primary-600 md:text-sm"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {siteBrand.name} · 主播与网红女神专题合集
          </p>
          <p className="text-xs text-foreground-500">
            本站内容为演示展示用途，观看与服务请以实际客户端为准
          </p>
        </div>
      </div>
    </footer>
  );
}